'use strict';

class creditNoteService {
  constructor($http) {
    this.$http = $http;
  }

  get(number) {
    return this.$http.get(`/invoices/credit-notes/${number}`);
  }

  send(number, params) {
    return this.$http.post(`/invoices/${number}/credit-notes`, params);
  }

  sendAgain(number, params) {
    return this.$http.post(`/invoices/credit-notes/${number}/send`, params);
  }

  /* DRAFTS */
  getDraft(number) {
    return this.$http.get(`/invoices/credit-notes/drafts/${number}`);
  }

  saveDraft(params) {
    return this.$http.post(`/invoices/credit-notes/drafts`, params);
  }

  updateDraft(number, params) {
    return this.$http.put(`/invoices/credit-notes/drafts/${number}`, params);
  }

  deleteDraft(number) {
    return this.$http.delete(`/invoices/credit-notes/drafts/${number}`);
  }
}

creditNoteService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('creditNoteService', creditNoteService);
